import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { DoenkidsSessionProvider } from 'src/providers/session.provider';
import { IServiceResponse } from 'typings/api-generic';
import { AddActivityImprovedDialogComponent } from '../add-activity-improved/add-activity-improved-dialog.component';
import { ActivityPendingRemovalService } from 'src/api/activity/activity-pending-removal/activitiy-pending-removal.service';
import { I18nToastProvider } from 'src/providers/i18n-toast.provider';
import dayjs from 'dayjs';

interface IPendingRemovalActivity {
  organization_unit_id: number;
  show_until: Date;
  organization_unit_name: string;
}

@Component({
    selector: 'app-manage-activity-pending-removal',
    templateUrl: './manage-activity-pending-removal.component.html',
    styleUrls: ['./manage-activity-pending-removal.component.scss'],
    standalone: false
})
export class ManageActivityPendingRemovalComponent {
  public showUntil: FormControl = new FormControl(dayjs().add(1, 'month').toDate());

  private removedOrganizationUnitIds: number[] = [];

  public get pendingRemovalActivities(): IPendingRemovalActivity[] {
    return this.data.pendingRemovalActivities?.filter((activity) => {
      return !this.removedOrganizationUnitIds.includes(activity.organization_unit_id);
    }) || [];
  }

  constructor(
    public dialogRef: MatDialogRef<AddActivityImprovedDialogComponent>,
    private $session: DoenkidsSessionProvider,
    private $activityPendingRemovalService: ActivityPendingRemovalService,
    private $toast: I18nToastProvider,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      activityId: number;
      pendingRemovalActivities?: IPendingRemovalActivity[];
    },
  ) {
  }

  closeDialog(): void {
    this.dialogRef.close();
  }


  async removeActivityPendingRemoval(organizationUnitID: number): Promise<IServiceResponse> {
    this.dialogRef.close();
    const result = await this.$activityPendingRemovalService.remove(organizationUnitID, this.data.activityId);

    this.removedOrganizationUnitIds.push(organizationUnitID);

    this.$toast.success('activity.pending_removal.remove-success');
    return result;
  }

  async onOkClick(): Promise<void> {
    this.dialogRef.close(this.showUntil.value);
    const organizationUnitId = (await firstValueFrom(this.$session.getOrganizationUnit$)).id;
    await this.$activityPendingRemovalService.update(organizationUnitId, this.data.activityId, this.showUntil.value);
    this.$toast.success('activity.pending_removal.update-success');
  }
}
